import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

export const useAddAttendee = () => {
  const { t } = useTranslation(['attendees'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const addAttendee = async (eventId, clientId) => {
    try {
      setIsError(false)
      setIsLoading(true)

      await API.addEventMember(eventId, clientId)

      displaySnackbar(t('attendees:notifications.attendeeAdded'))
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || t('attendees:notifications.couldNotAddAttendee')
      displaySnackbar(errorMessage, true)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return { addAttendee, isLoading, isError }
}
